import { render, staticRenderFns } from "./12MedalManagement.vue?vue&type=template&id=af3ad5d0&scoped=true&"
import script from "./12MedalManagement.vue?vue&type=script&lang=js&"
export * from "./12MedalManagement.vue?vue&type=script&lang=js&"
import style0 from "./12MedalManagement.vue?vue&type=style&index=0&id=af3ad5d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3ad5d0",
  null
  
)

export default component.exports